BookingApp.controller('ErrorController',function($scope,ErrorServices){		
	
	$scope.data = ErrorServices.getData();
	//console.log($scope.data);
	
});